<div
  class="container m-b-20"
  fxLayout="row"
  fxLayoutAlign="end"
  fxLayoutGap="20px"
  matomoForm="users-header"
>
  <button
    mat-raised-button
    color="primary"
    [routerLink]="['create']"
    matomoClick="create-user-button"
    (click)="onCreateUserClick()"
  >
    <fa-icon icon="plus"></fa-icon>&nbsp;&nbsp;
    {{ "USERS.CREATE_USER" | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    matomoClick="download-users-button"
    (click)="downloadUsers()"
    [disabled]="isDownloading"
  >
    <fa-icon icon="download"></fa-icon>&nbsp;&nbsp;
    {{ isDownloading ? ('USERS.DOWNLOADING' | translate) : ('USERS.DOWNLOAD_USERS' | translate) }}
  </button>
</div>

<div class="container" matomoForm="users-main-container">
  <div fxLayout="row" fxLayoutGap="20px" matomoForm="users-filter-section">
    <mat-form-field fxFlex>
      <mat-label>{{ "USERS.FILTER" | translate }}</mat-label>
      <input
        matInput
        #filterInput
        (keyup)="applyFilter($event.target.value)"
        matomoClick="users-filter-input"
        placeholder="{{ 'USERS.SEARCH_PLACEHOLDER' | translate }}"
      />
    </mat-form-field>

    <mat-form-field fxFlex>
      <mat-label>{{ "USERS.ROLE_FILTER" | translate }}</mat-label>
      <mat-select
        [value]="roleFilter"
        (selectionChange)="roleFilter = $event.value; searchUsers()"
      >
        <mat-option [value]="null">{{ "USERS.ALL" | translate }}</mat-option>
        <mat-option *ngFor="let role of rolesData" [value]="role.name">
          {{ role.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex>
      <mat-label>{{ "USERS.ENABLED_FILTER" | translate }}</mat-label>
      <mat-select
        [value]="enabledFilter"
        (selectionChange)="enabledFilter = $event.value; searchUsers()"
      >
        <mat-option [value]="null">{{ "USERS.ALL" | translate }}</mat-option>
        <mat-option [value]="true">{{ "USERS.ACTIVE" | translate }}</mat-option>
        <mat-option [value]="false">{{ "USERS.DISABLED" | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button
      mat-icon-button
      *ngIf="textFilter || roleFilter !== null || enabledFilter !== null"
      (click)="clearFilters(filterInput)"
      [matTooltip]="'USERS.CLEAR_FILTERS' | translate"
      matomoClick="users-clear-filters-button"
    >
      <fa-icon icon="times" size="lg"></fa-icon>
    </button>
  </div>

  <div class="mat-elevation-z8" matomoForm="users-table-container">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matomoForm="users-data-table"
    >
      <ng-container matColumnDef="firstname">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          matomoClick="users-sort-firstname"
        >
          {{ "USERS.FIRST_NAME" | translate }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.firstname }}</td>
      </ng-container>

      <ng-container matColumnDef="lastname">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          matomoClick="users-sort-lastname"
        >
          {{ "USERS.LAST_NAME" | translate }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.lastname }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          matomoClick="users-sort-email"
        >
          {{ "USERS.EMAIL" | translate }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          matomoClick="users-sort-status"
        >
          {{ "USERS.STATUS" | translate }}
        </th>
        <td mat-cell *matCellDef="let user">
          <fa-icon
            icon="stop"
            [style.color]="user.enabled ? 'green' : 'red'"
            [matTooltip]="
              user.enabled
                ? ('USERS.ACTIVE' | translate)
                : ('USERS.DISABLED' | translate)
            "
          ></fa-icon>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        matomoForm="users-table-header"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [routerLink]="[row.id]"
        class="select-row"
        matomoClick="users-row-click"
        (click)="onUserClick(row)"
      ></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      matomoForm="users-paginator"
    ></mat-paginator>
  </div>
</div>
